export default "__VITE_ASSET__BrQTeRo8__"